module.exports = __webpack_public_path__ + "static/media/leading-wellbeing.d137f1e9.png";